import './App.css';
import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { ToastContainer } from "react-toastify";

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/home/Dashboard';
import Forgetpass from './auth/Forgetpass';
import Wallet from './panel/Wallet';

import Loancategory from './components/master/Loancategory';
import Insurancecat from './components/master/Insurancecat';
import Loandetails from './components/master/Loandetails';
import Insurancedetails from './components/master/Insurancedetails';
import Loancustomers from './components/loan/Loancustomers';
import Customerstatus from './components/loan/Customersstatus';
import Insurancecustomers from './components/insurance/Insurancecustomers';
import Insurancecuststatus from './components/insurance/Insurancecuststatus';
import Affiliatebank from './components/master/Affiliatebank';
import Affiliateproducts from './components/master/Affiliateproducts';
import Affiliatesources from './components/master/Affiliatesources';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });


  return (
    <div className="wrapper">
      <Router>
          {
            !user ?
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/login' element={<Login />} />
                <Route path='/forgot-password' element={<Forgetpass />} />
               {/* <Route path='/Register' element={<Register />} />  */}
              </Routes>
              :
              <>
                <Header />
                <Menu />
                <div className='content-wrapper p-3' style={{ marginBottom: 50 }}>
                  <Routes>
                    <Route path='/affiliate-sources' element={<Affiliatesources />} />
                    <Route path='/affiliate-products' element={<Affiliateproducts />} />
                    <Route path='/home' element={<Dashboard />} />
                    <Route path='/loan-category' element={<Loancategory />} />
                    <Route path='/insurance-category' element={<Insurancecat />} />
                    <Route path='/loan-details' element={<Loandetails />} />
                    <Route path='/insurance-details' element={<Insurancedetails />} />
                    <Route path='/loan-customers' element={<Loancustomers />} />
                    <Route path='/loancustomers/:value' element={<Customerstatus />} />
                    <Route path='/insurance-customers' element={<Insurancecustomers />} />
                    <Route path='/insurancecustomers/:value' element={<Insurancecuststatus />} />
                    <Route path='/affiliate-banks' element={<Affiliatebank />} />

                  </Routes>

                </div>
                {/* <Footer /> */}
              </>
          }
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </div >
  );
}

export default App;
